import React from "react";
import { ApiEndorseSkill } from "src/api/types";
import Badge from "src/components/Badge";

interface SkillBadgeProps {
	skill: ApiEndorseSkill;
	onClick?: () => void;
}

const SkillBadge = ({ skill, onClick }: SkillBadgeProps) => {
	return (
		<Badge
			variant={skill.has_endorsed ? "primary" : "dark"}
			className={`${onClick && "cursor-pointer"} transition-all gap-2`}
			{...{ onClick }}
		>
			{skill.name}
			<div className="px-2 py-[2px] rounded-sm relative overflow-hidden">
				<div
					className={`${
						skill.has_endorsed ? "bg-dark" : "bg-primary"
					} opacity-20 transition-all absolute inset-0`}
				></div>
				<div className="div flex gap-2 items-center relative z-10">
					<i
						className={`${
							skill.has_endorsed ? "fas" : "far"
						} fa-thumbs-up`}
					></i>
					<span>{skill.endorsements}</span>
				</div>
			</div>
		</Badge>
	);
};

export default SkillBadge;
